import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "storefront",
    title: "Retail & Hospitality",
    description:
      "Cleaning services tailored for shops, restaurants, and hospitality venues with high footfall.",
  },
  {
    icon: "schedule",
    title: "Flexible Scheduling",
    description:
      "We work around your operating hours — early morning, evening, or weekend cleans available.",
  },
  {
    icon: "verified",
    title: "Trained Professionals",
    description:
      "Our team is fully trained, vetted, and equipped to maintain commercial environments to a high standard.",
  },
  {
    icon: "autorenew",
    title: "Consistent Results",
    description:
      "Regular quality checks ensure your premises are consistently clean with every visit.",
  },
];

function Commercial_Section1() {
  return (
    <ServiceHighlights
      title="Why Choose Our Commercial Cleaning?"
      description="We deliver reliable, professional cleaning services for retail, hospitality, and commercial spaces — keeping your premises presentable and hygienic for staff and customers alike."
      items={items}
    />
  );
}

export default Commercial_Section1;
